import { Outlet } from "react-router"
import { Layout } from "./Layout"

/**
 * Layout route for the whole app: the shell (sidebar, header, chat panel)
 * mounts once and pages render in the Outlet. Pages keep rendering
 * `<Layout headerLeftElement=… />`, which inside the shell only fills its
 * header, so navigating no longer remounts the sidebar.
 */
export function AppShellRoute() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  )
}
